import React from 'react';
import logo from '../../assets/logo1-removebg-preview.png';

const PrivacyPolicy: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    {/* Header avec logo */}
    <div className="bg-white shadow-sm border-b">
      <div className="max-w-4xl mx-auto px-6 py-4">
        <img 
          src={logo} 
          alt="Genius Vente Logo" 
          className="h-12 w-auto"
        />
      </div>
    </div>
    
    {/* Contenu */}
    <div className="max-w-2xl mx-auto p-6 text-gray-800 bg-white my-8 rounded-lg shadow-sm">
      <h1 className="text-2xl font-bold mb-4">Politique de confidentialité – Genius Vente</h1>
      <p className="mb-4">Chez <strong>Genius Vente</strong>, nous respectons votre vie privée.<br/>
      Les données que nous collectons ont pour seul objectif <strong>d'améliorer votre expérience utilisateur</strong> et de vous fournir un service plus personnalisé, plus fluide et plus utile au quotidien.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">Quelles données nous collectons</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Votre nom, numéro de téléphone ou email lors de la création de votre compte</li>
        <li>Vos actions dans l'application (ex. ventes, produits ajoutés)</li>
        <li>Les paramètres que vous configurez dans l'application</li>
      </ul>
      <p className="mb-4">Ces données nous permettent :</p>
      <ul className="list-disc list-inside mb-4">
        <li>D'adapter l'application à vos besoins réels</li>
        <li>D'optimiser les performances de l'application</li>
        <li>De vous envoyer des alertes utiles (stock faible, rapport quotidien)</li>
      </ul>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">Pourquoi nous les collectons</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Pour vous offrir une expérience personnalisée</li>
        <li>Pour détecter et corriger rapidement les bugs ou lenteurs</li>
        <li>Pour vous proposer des fonctionnalités pertinentes selon votre usage</li>
      </ul>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">Sécurité des données</h2>
      <p className="mb-4">Vos données sont stockées de façon sécurisée.<br/>
      Nous mettons en place des mesures techniques pour éviter la perte, l'accès non autorisé ou la modification de vos informations.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">Pas de vente ou de partage</h2>
      <p className="mb-4">Nous ne vendons jamais vos données.<br/>
      Nous ne les partageons pas avec des tiers, sauf si vous y consentez ou si la loi l'exige.</p>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mt-6 mb-2">Votre consentement</h2>
      <p className="mb-4">En utilisant <strong>Genius Vente</strong>, vous acceptez que certaines de vos données soient utilisées uniquement pour <strong>améliorer votre expérience</strong>.<br/>
      Si vous avez la moindre question sur la confidentialité ou la gestion de vos données, vous pouvez nous contacter à tout moment.</p>
      <hr className="my-4" />
      <p className="text-sm text-gray-500 mt-6">Politique en vigueur depuis le :<br/>19 janvier 2023</p>
    </div>
  </div>
);

export default PrivacyPolicy; 